var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChickenEggsBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.221,
    height: 21.043,
    viewBox: "0 0 22.221 21.043",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3386",
    "data-name": "Group 3386",
    transform: "translate(0.459 0.459)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_166",
    "data-name": "Ellipse 166",
    d: "M8.319-.35A10.26,10.26,0,0,1,14.41,1.525a5.805,5.805,0,0,1,2.578,4.642A5.805,5.805,0,0,1,14.41,10.81a10.26,10.26,0,0,1-6.091,1.875A10.26,10.26,0,0,1,2.228,10.81,5.805,5.805,0,0,1-.35,6.167,5.805,5.805,0,0,1,2.228,1.525,10.26,10.26,0,0,1,8.319-.35Zm0,12.335c4.394,0,7.969-2.61,7.969-5.817S12.713.35,8.319.35.35,2.96.35,6.167,3.925,11.985,8.319,11.985Z",
    transform: "translate(0 15.327) rotate(-67.105)",
    fill: "#22294D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3530",
    "data-name": "Path 3530",
    d: "M525.455,1804.956a11.078,11.078,0,0,1-3.592-.582.35.35,0,0,1,.226-.662,10.381,10.381,0,0,0,3.365.545c4.394,0,7.969-2.61,7.969-5.818,0-2.65-2.453-4.965-5.966-5.631a.35.35,0,1,1,.13-.688c3.848.73,6.536,3.328,6.536,6.319a5.805,5.805,0,0,1-2.578,4.642A10.259,10.259,0,0,1,525.455,1804.956Z",
    transform: "translate(-512.36 -1786.359)",
    fill: "#22294D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChickenEggsBlue);
export default __webpack_public_path__ + "static/media/chicken_eggs_blue.95ad8abe75ff1e35245f4d2a574ce30f.svg";
export { ForwardRef as ReactComponent };